import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Card, Row, Col, DatePicker, Button } from "antd";
import { TableComp } from "sz-react-utils";
import Request from "../../request";
import moment from "moment";



const { RangePicker } = DatePicker;


class ConversionReport extends React.Component {
    state = {
        time: null,
    }

    componentDidMount() {

    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            const dateParams = {};
            if (this.state.time && this.state.time.from && this.state.time.to) {
                dateParams.startDate = this.state.time.from.format('YYYY-MM-DD');
                dateParams.endDate = this.state.time.to.format('YYYY-MM-DD');
            }
            let response = await Request.getBranchWiseConversionReport({ ...params, ...dateParams });
            resolve(response);
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    from: date[0],
                    to: date[1],
                },
            },
            () => {
                this.reload();
            }
        );
        if (date[0] === undefined) {
            setTimeout(() => {
                this.reload();
            }, 500);
        }
    };

    onOk = value => {
        this.reload()
    }

    reload = () => {
        this.table.current.reload();
    };

    render() {
        const columns = [
            {
                title: 'Sr. No.',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },

            {
                title: 'Branch Name',
                key: 'branchName',
                searchTextName: 'branchName',
                render: (text, record) => {
                    const branchId = record.branchId._id;
                    return (
                        <Button
                            type="link"
                            onClick={() => window.open(`/counsellor-conversion?branchId=${branchId}`, "_blank")}
                        >
                            {record.branchId.branchName}
                        </Button>
                    );
                }
            },

            {
                title: 'Total Leads',
                key: 'total',
            },
            {
                title: 'Converted Leads',
                key: 'converted'
            },
            {
                title: 'Conversion Ratio',
                key: 'conversionRatio',
                render: (text, record) => {
                    if (record.total === 0) return '0%';
                    const ratio = (record.converted / record.total) * 100;
                    return `${ratio.toFixed(2)}%`;
                }
            }

        ];
        return (
            <PageHeaderWrapper title="Branch Wise Conversion Report">
                <Card bordered={true}>
                    <Row>
                        <Col span={8}>
                            <label>Search By Date</label><br />
                            <RangePicker
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        pagination={false}
                        bordered
                    />
                </Card>


            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConversionReport)